import React from "react";
import useResponsiveFontSize from "./useResponsiveFontSize";

const ResponsiveText = ({ children }) => {
  const baseFontSize = useResponsiveFontSize();

  // Calculate font sizes for different elements relative to base
  const headingFontSize = `calc(${baseFontSize} * 1.5)`;    // 150% of base
  const paragraphFontSize = baseFontSize;                    // 100% of base
  const BoxFontSize = `calc(${baseFontSize} * 0.7)`;        // 70% of base
  const HFontSize = `calc(${baseFontSize} * 0.90)`;         // 90% of base
  const BOldFontSize = `calc(${baseFontSize} * 0.8)`;       // 80% of base
  
  return (
    <div>
      <style>
        {`
          h4, h5, h6 {
            font-size: ${headingFontSize};
          }
          h1 {
            font-size: ${BoxFontSize};
          }
          p {
            font-size: ${paragraphFontSize};
            font-weight: normal;    
          }
          h3 {
            font-size: ${HFontSize};
            font-weight: normal;    
          }
          .text-bold {
            font-size: ${BOldFontSize};
            font-weight: normal;    
          }
        `}
      </style>
      {children}
    </div>
  );
};

export default ResponsiveText;
